import React from 'react';
export function AboutStory() {
  return <section id="about" className="py-24 bg-brand-charcoal text-brand-light overflow-hidden" data-id="element-1">
      <div className="container mx-auto px-6 md:px-12" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-3">
          {/* Image Column */}
          <div className="w-full lg:w-1/2 relative" data-id="element-4">
            <div className="absolute inset-0 bg-brand-orange rounded-3xl transform rotate-3 scale-105 opacity-20" data-id="element-5"></div>
            <img src="https://cdn.magicpatterns.com/uploads/h7y6pm2h3nBUWeevicJRJk/valley-mobile-about.jpg" alt="Groomer with a happy dog" className="relative z-10 rounded-3xl w-full h-[500px] object-cover shadow-2xl border border-brand-light/10" data-id="element-6" />
            {/* Decorative Element */}
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-brand-pink rounded-full blur-3xl opacity-30 z-0" data-id="element-7"></div>
          </div>

          {/* Text Column */}
          <div className="w-full lg:w-1/2 relative z-10" data-id="element-8">
            <h2 className="text-4xl md:text-5xl font-heading mb-6 leading-tight" data-id="element-9">
              We Treat Your Pet <br data-id="element-10" />
              <span className="text-brand-orange" data-id="element-11">Like Family</span>
            </h2>

            <div className="space-y-6 text-brand-light/80 text-lg font-light" data-id="element-12">
              <p data-id="element-13">
                At The Valley Mobile Grooming, we believe pets deserve the same
                love and care as anyone else in the family. That's why we never
                use cages, kennel dryers, or harsh chemicals. Our team brings a
                professional, organized approach to every groom — mobile or
                in-salon.
              </p>
              <p data-id="element-14">
                Whether we pull up in your driveway or you visit our Goodyear
                salon, your pet's comfort and safety come first. Always.
              </p>
            </div>

            <div className="mt-10" data-id="element-15">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent border-2 border-brand-pink text-brand-pink px-8 py-4 rounded-full font-semibold hover:bg-brand-pink hover:text-brand-light transition-all duration-300 min-h-[48px]" data-id="element-16">
                Follow Us on Instagram
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}